import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import { REHYDRATE } from 'redux-persist/lib/constants';
import { put, takeEvery } from 'redux-saga/effects';

import { authenticationRequired } from '../../actions/authentication/authenticationRequired';
import getAuthenticationToken from '../getAuthenticationToken';
import getPublicResponse from '../getPublicResponse';

function* persistAuthenticateSaga() {
  let joined = false;
  const token = yield getAuthenticationToken();
  if (token) {
    const response = yield getPublicResponse(PublicServerPlaceEvent.verifyPlaceToken, { token });
    const { error } = response;
    if (!error) {
      joined = true;
    }
  }
  if (!joined) {
    yield put(authenticationRequired());
  }
}

export default function* watchPersistAuthenticateSaga() {
  yield takeEvery(REHYDRATE, persistAuthenticateSaga);
}
